
import React, { useState, useEffect, use, useContext, useRef } from "react";
import { RxCross2 } from "react-icons/rx";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import axios from "axios";
import toast from "react-hot-toast";
import { useTranslation } from "react-i18next";
import CancelButton from "../../Components/CommonComponent/Button/CancelButton";
import SaveButton from "../../Components/CommonComponent/Button/SaveButton";
import { CommonContext } from "../../App";
import api from "../../services/api";
import { FiChevronDown } from "react-icons/fi";


export default function CreateManager({ handleSave, handleCancel, loading, selectedManager }) {
   const { userData } = useContext(CommonContext)
     const adminId=userData?.user?.id ;      
   const managerId=userData?.user?.admin_id ;      
   const userRole=userData?.user?.role;
  const getDataById=userRole ==="admin"?adminId:managerId;
  const [form, setForm] = useState({
    first_name: "",
    last_name: "",
    email: "",
    phone: "",
    address: "",
    password: "",
    confirm_password: "",
    rights: [],
    branches: [],
    status: "Active",
    adminId: getDataById || null,
  });
  let branchesId = userData.user.branches;

  if (typeof branchesId === "string") {
    try {
      branchesId = JSON.parse(branchesId);
    } catch {
      branchesId = [];
    }
  }


  const { t } = useTranslation();
  const [errors, setErrors] = useState({});
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [branchOptions, setBranchOptions] = useState([]);
 
  const [rightsOpen, setRightsOpen] = useState(false);
  const [branchesOpen, setBranchesOpen] = useState(false);
  const rightsRef = useRef(null);
  const branchesRef = useRef(null);

  // Fetch branches from API
  useEffect(() => {
    const fetchBranches = async () => {
      try {
        if (userData.user.role === "admin"){
        const response = await api.get(`branch/get-all/${userData.user.id}`);
        setBranchOptions(response.data.branches);
        }else if (branchesId?.length > 0) {
          const ids = branchesId.join(",");
          const response = await api.get(`branch/by-id?id=${ids}`);
          setBranchOptions(response.data.branches);
        }
       
        // console.log("check branches", response.data.branches)
        
      } catch (error) {
        toast.error("Error fetching branches:", error);
      }
    };
    fetchBranches();
  }, []);

  // Load selected manager data if editing
  useEffect(() => {
    if (selectedManager) {
      setForm({
        first_name: selectedManager.first_name || "",
        last_name: selectedManager.last_name || "",
        email: selectedManager.email || "",
        phone: selectedManager.phone || "",
        address: selectedManager.address || "",
        password: "",
        confirm_password: "",
        rights: selectedManager.rights || [],
        branches: selectedManager.branches
          ? selectedManager.branches.map((b) => b.id)
          : [],
        status: selectedManager.status || "Active",
        adminId: getDataById || null,
      });
    } else {
      setForm({
        first_name: "",
        last_name: "",
        email: "",
        phone: "",
        address: "",
        password: "",
        confirm_password: "",
        rights: [],
        branches: [],
        status: "Active",
        adminId: getDataById || null,
      });
    }
  }, [selectedManager]);
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (rightsRef.current && !rightsRef.current.contains(event.target)) {
        setRightsOpen(false);
      }
      if (branchesRef.current && !branchesRef.current.contains(event.target)) {
        setBranchesOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);


  // const rightsOptions = ["View Reports", "Manage Users", "Approve Requests", "Full Access"];
  const rightsOptions = [
    { name: "Dashboard", nameValue: "dashboard" }, 
    { name: "Day Book", nameValue: "day_book" }, 
    { name: "Entry", nameValue: "entry" }, 
    { name: "Account Books", nameValue: "account_book" }, 
    { name: "Inventory Books", nameValue: "inventory_book" }, 
    { name: "Reports", nameValue: "reports" }, 
    // { name: "Settings", nameValue: "settings" },
    { name: "Create Manager (Setting)", nameValue: "create_manager" }
  ];

  const handleChange = (e) => {
    const { name, value } = e.target;

    if (name === "phone") {
      if (!/^\d{0,10}$/.test(value)) return;
    }

    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleMultiSelect = (field, value) => {
    if (!value) return;
    setForm((prev) => ({
      ...prev,
      [field]: prev[field].includes(value) ? prev[field] : [...prev[field], value],
    }));
  };

  const removeSelectedValue = (field, value) => {
    setForm((prev) => ({
      ...prev,
      [field]: prev[field].filter((v) => v !== value),
    }));
  };

  const validate = () => {
    let tempErrors = {};
    if (!form.first_name.trim()) tempErrors.first_name = t('firstNameRequired');
    if (!form.phone.trim()) tempErrors.phone = t('phoneRequired');
    if (!selectedManager) {
      if (!form.password.trim()) tempErrors.password = t('passwordRequired');
      if (!form.confirm_password.trim()) tempErrors.confirm_password = t('confirmPasswordRequired');
      if (form.password && form.confirm_password && form.password !== form.confirm_password) {
        tempErrors.confirm_password = t('passwordDoDotMatch');
      }
    }
    setErrors(tempErrors);
    return Object.keys(tempErrors).length === 0;
  };

  const onSubmit = () => {
    if (!validate()) return;
    handleSave(form);
  };

  return (
    <div className="bg-white p-2 rounded-md shadow-lg w-[800px]">
      {/* Header */}
      <div className="bg-theme-headerBg text-white mb-2 p-1 rounded-1">
        <div className=" font-medium text-center ">
          {selectedManager ? t("editManager") : t("createNewManager")}
        </div>
      </div>

      <div className="space-y-3 text-sm px-1">
        {/* Name Fields */}
        <div className="flex gap-3">
          <div className="w-1/2">
            <label className="font-medium t">{t('firstName')} </label>
            <input
              name="first_name"
              value={form.first_name}
              onChange={handleChange}
              placeholder="First Name"
              className="border p-1 rounded-1 w-full outline-none capitalize"
            />
            {errors.first_name && <p className="text-red-500 text-sm">{errors.first_name}</p>}
          </div>
          <div className="w-1/2">
            <label className="font-medium">{t('lastName')} </label>
            <input
              name="last_name"
              value={form.last_name}
              onChange={handleChange}
              placeholder="Last Name"
              className="border p-1 rounded-1 w-full outline-none capitalize"
            />
          </div>
        </div>

        {/* Email & Phone */}
        <div className="flex gap-3">
          <div className="w-1/2">
            <label className="font-medium">{t('email')} </label>
            <input
              name="email"
              type="email"
              value={form.email}
              onChange={handleChange}
              placeholder={t("email")}
              className="border p-1 rounded-1 w-full outline-none "
            />
          </div>

          <div className="w-1/2">
            <label className="font-medium">{t('phone')} </label>
            <input
              name="phone"
              value={form.phone}
              onChange={handleChange}
              placeholder={t("phone")}
              className="border p-1 rounded-1 w-full outline-none"
            />
            {errors.phone && <p className="text-red-500 text-sm">{errors.phone}</p>}
          </div>
        </div>

        {/* Address */}
        <div>
          <label className="font-medium">{t('address')} </label>
          <textarea
            name="address"
            value={form.address}
            onChange={handleChange}
            placeholder={t("address")}
            className="border p-1 rounded-1 w-full outline-none capitalize"
          />
        </div>

        {/* Password Fields */}
        {!selectedManager && (
          <div className="flex gap-3">
            <div className="w-1/2 relative">
              <label className="font-medium">{t('password')} </label>
              <input
                type={showPassword ? "text" : "password"}
                name="password"
                value={form.password}
                onChange={handleChange}
                placeholder={t("password")}
                className="border p-1 rounded-1 w-full outline-none pr-10"
              />
              <span
                className="absolute right-3 top-7 cursor-pointer text-gray-500"
                onClick={() => setShowPassword((prev) => !prev)}
              >
                {showPassword ? <FaEyeSlash /> : <FaEye />}
              </span>
              {errors.password && <p className="text-red-500 text-sm mt-1">{errors.password}</p>}
            </div>

            <div className="w-1/2 relative">
              <label className="font-medium">{t('confirmPassword')} </label>
              <input
                type={showConfirmPassword ? "text" : "password"}
                name="confirm_password"
                value={form.confirm_password}
                onChange={handleChange}
                placeholder="Confirm Password"
                className="border p-1 rounded-1  w-full outline-none pr-10"
              />
              <span
                className="absolute right-3 top-7 cursor-pointer text-gray-500"
                onClick={() => setShowConfirmPassword((prev) => !prev)}
              >
                {showConfirmPassword ? <FaEyeSlash /> : <FaEye />}
              </span>
              {errors.confirm_password && (
                <p className="text-red-500 text-sm mt-1">{errors.confirm_password}</p>
              )}
            </div>
          </div>
        )}

        {/* Rights & Branches */}
        {/* <div className="flex gap-3">
        
          <div className="w-1/2">
            <label className="font-medium">{t('rights')} </label>
            <select
              onChange={(e) => {
                handleMultiSelect("rights", e.target.value);
                e.target.value = "";
              }}
              className="border p-1 rounded-1 w-full"
              value=""
            >
              <option value="">{t('selectRight')} </option>
              {rightsOptions.map((r) => (
                <option key={r.name} value={r.nameValue}>
                  {r.name}
                </option>
              ))}
            </select>
            <div className="flex flex-wrap gap-2 mt-2">
             
              {form.rights.map((r) => {
            const rightObj = rightsOptions.find(opt => opt.nameValue === r);

            return (
              <span
                key={r}
                className="bg-theme-headerBg text-theme-color px-2 py-1 rounded-1 flex items-center gap-3"
              >
                {rightObj?.name || r}
                <RxCross2
                  className="cursor-pointer text-theme-color"
                  onClick={() => removeSelectedValue("rights", r)}
                />
              </span>
            );
          })}

            </div>
          </div>

       
          <div className="w-1/2">
            <label className="font-medium">{t('branches')} </label>
            <select
              onChange={(e) => {
                 const selectedId = parseInt(e.target.value);
            if (!selectedId) return;
            handleMultiSelect("branches", selectedId);
            e.target.value = "";
          }}
             className="border p-1 rounded-1     w-full"
              value=""
            >
              <option value="">{t('selectBranch')} </option>
              {branchOptions &&  branchOptions.map((b) => (
                <option key={b.id} value={b.id}>
                  {b.name}
                </option>
              ))}
            </select>
            <div className="flex flex-wrap gap-2 mt-2">
              {form.branches.map((branchId) => {
                const branch = branchOptions.find((b) => b.id === branchId);
                return (
                  <span
                    key={branchId}
                    className="bg-theme-headerBg text-theme-color px-2 py-1 rounded-1 flex items-center gap-3"
                  >
                   {branch ? branch.name : branchId}
                    <RxCross2
                      className="cursor-pointer text-theme-color"
                      onClick={() => removeSelectedValue("branches", branchId)}
                    />
                  </span>
                );
              })}
            </div>
          </div>
        </div> */}
        {/* Rights & Branches */}
        <div className="flex gap-3">
          {/* Rights */}


          {/* Branches */}
          <div className="w-1/2 relative" ref={branchesRef}>
            <label className="font-medium">{t("branches")}</label>

            {/* Input box */}
            <div
              className="border p-1 rounded-1 w-full bg-white cursor-pointer flex justify-between items-center"
              onClick={() => setBranchesOpen(prev => !prev)}
            >
              <span className="text-gray-500">{t("selectBranch")}</span>
              <FiChevronDown
                className={`transition-transform duration-200 ${branchesOpen ? "rotate-180" : ""}`}
              />
            </div>

            {/* UL Dropdown */}
            {branchesOpen && (
              <ul className="absolute z-50 w-full bg-white border rounded-1 mt-1 max-h-48 overflow-y-auto shadow-md p-0 custom-scrollbar">
                {branchOptions?.map((b) => (
                  <li
                    key={b.id}
                    onClick={() => {
                      handleMultiSelect("branches", b.id);
                      setBranchesOpen(false);
                    }}
                    className="px-2 py-1 cursor-pointer hover:bg-theme-headerBg hover:text-theme-color"
                  >
                    {b.name}
                  </li>
                ))}
              </ul>
            )}

            {/* Chips */}
            <div className="flex flex-wrap gap-2 mt-2">
              {form.branches.map((branchId) => {
                const branch = branchOptions.find((b) => b.id === branchId);
                return (
                  <span
                    key={branchId}
                    className="bg-theme-headerBg text-theme-color px-2 py-1 rounded-1 flex items-center gap-3"
                  >
                    {branch ? branch.name : branchId}
                    <RxCross2
                      className="cursor-pointer text-theme-color"
                      onClick={() => removeSelectedValue("branches", branchId)}
                    />
                  </span>
                );
              })}
            </div>
          </div>
          <div className="w-1/2 relative" ref={rightsRef}>
            <label className="font-medium">{t("rights")}</label>

            {/* Input box */}
            <div
              className="border p-1 rounded-1 w-full bg-white cursor-pointer flex justify-between items-center"
              onClick={() => setRightsOpen(prev => !prev)}
            >
              <span className="text-gray-500">{t("selectRight")}</span>
              <FiChevronDown
                className={`transition-transform duration-200 ${rightsOpen ? "rotate-180" : ""}`}
              />
            </div>

            {/* UL Dropdown */}
            {rightsOpen && (
              <ul className="absolute z-50 w-full bg-white border rounded-1 mt-1 max-h-48 overflow-y-auto shadow-md p-0 custom-scrollbar">
                {rightsOptions.map((r) => (
                  <li
                    key={r.nameValue}
                    onClick={() => {
                      handleMultiSelect("rights", r.nameValue);
                      setRightsOpen(false);
                    }}
                    className="px-2 py-1 cursor-pointer hover:bg-theme-headerBg hover:text-theme-color"
                  >
                    {r.name}
                  </li>
                ))}
              </ul>
            )}

            {/* Chips */}
            <div className="flex flex-wrap gap-2 mt-2">
              {form.rights.map((r) => {
                const rightObj = rightsOptions.find(opt => opt.nameValue === r);
                return (
                  <span
                    key={r}
                    className="bg-theme-headerBg text-theme-color px-2 py-1 rounded-1 flex items-center gap-3"
                  >
                    {rightObj?.name || r}
                    <RxCross2
                      className="cursor-pointer text-theme-color"
                      onClick={() => removeSelectedValue("rights", r)}
                    />
                  </span>
                );
              })}
            </div>
          </div>
        </div>



      </div>

      {/* Actions */}
      <div className="flex justify-end gap-3 mt-3">

        <CancelButton onClick={handleCancel} text={t('cancel')} />

        <SaveButton onClick={onSubmit} text={t(loading ? t('procssing') : t('save'))} disabled={loading} />
      </div>
    </div>
  );
}

